import AddCandidates from "./partials/AddCandidates";
import CandidateTable from "./partials/CandidateTable";

const StepFive = () => {
  return (
    <>
      <AddCandidates />
      <CandidateTable />
    </>
  );
};

export default StepFive;
